export function planningDateRange(day: string, duration: number, sourceStart?: string | null): { startTime: string; endTime: string } {
  const start = new Date(`${day}T09:00:00`);
  const source = sourceStart ? new Date(sourceStart) : null;
  if (source && Number.isFinite(source.getTime())) {
    start.setHours(source.getHours(), source.getMinutes(), source.getSeconds(), source.getMilliseconds());
  }
  return { startTime: start.toISOString(), endTime: new Date(start.getTime() + duration * 60000).toISOString() };
}

export function planningLocalDay(value: string): string {
  const date = new Date(value);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}
